import { FlexBox } from '@trmediaab/zebra';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Spinner from '~/components/Spinner';

import { getError, getFeed, getIsFetching } from './selectors';
import TeaserList from './TeaserList';

const mapStateToProps = createStructuredSelector({
  feed: getFeed,
  error: getError,
  isFetching: getIsFetching,
});

const Frontpage = ({ feed, error, isFetching }) => (
  <FlexBox bg="background.secondary">
    <Spinner loading={!feed && isFetching} error={error}>
      {feed && <TeaserList data={feed} />}
    </Spinner>
  </FlexBox>
);

export default connect(mapStateToProps)(Frontpage);
